import { render, staticRenderFns } from "./BoxView.vue?vue&type=template&id=52c057b6&"
import script from "./BoxView.vue?vue&type=script&lang=js&"
export * from "./BoxView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports